import React from 'react';
import { withStyles } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import {
    lightSuccess,
    lightWarning,
    lightDanger,
    lightInfo
} from '@signaturit/react-components-library/src/style/commons/_colors';
const styles = {
    root: { boxShadow: 'none' },
    variantSuccess: {
        backgroundColor: `${lightSuccess} !important`,
        boxShadow: 'none !important',
        color: '#131314 !important',
    },
    variantError: {
        backgroundColor: `${lightDanger} !important`,
        boxShadow: 'none !important',
        color: '#131314 !important',
    },
    variantWarning: {
        backgroundColor: `${lightWarning} !important`,
        boxShadow: 'none !important',
        color: '#131314 !important',
    },
    variantInfo: {
        backgroundColor: `${lightInfo} !important`,
        boxShadow: 'none !important',
        color: '#131314 !important',
    },
};

export const DashboardSnackbarProvider = withStyles(styles)((props: any) => (
    <SnackbarProvider
        hideIconVariant
        preventDuplicate
        maxSnack={4}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        classes={props.classes}
    >
        {props.children}
    </SnackbarProvider>
));
